import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CellType, IgxDialogComponent } from '@infragistics/igniteui-angular';
import { BusStop } from 'src/app/models/bus-stop';
import { shoeSizes } from 'src/app/models/enums/shoeSizes';
import { Kid, KidForm } from 'src/app/models/kid';
import { PackageRequest } from 'src/app/models/package-request';
import { Parent } from 'src/app/models/parent';
import { MessagesService } from 'src/app/services/messages.service';
import { EditParentFormComponent } from '../edit-parent-form/edit-parent-form.component';
import { KidService } from 'src/app/services/kid.service';
import { Gender } from 'src/app/models/enums/gender';

@Component({
    selector: 'app-edit-kid-form',
    templateUrl: './edit-kid-form.component.html',
    styleUrls: ['./edit-kid-form.component.scss']
})
export class EditKidFormComponent {
    private _kid?: Kid;
    public kidForm: FormGroup<KidForm>;
    public kids: Kid[] = [];
    public parents: Parent[] = [];
    public stops: BusStop[] = [];
    public shoeSizes = shoeSizes;

    @Input()
    public request?: PackageRequest;

    @Input()
    public parent?: Parent;

    public get kid(): Kid | undefined {
        return this._kid;
    }
    @Input()
    public set kid(v: Kid | undefined) {
        this._kid = v;
        this.kidForm.reset(this._kid as any);
        this.dialogText = 'Редактирай';
        if (!this._kid) {
            this._kid = this._emptyKid();
            this.kidForm.reset(this._kid as any);
            this.dialogText = 'Добави';
            this.kidForm.controls.name.reset(this.request?.kidName);
            this.kidForm.controls.birthDate.reset(this.request?.kidBirth);
            this.kidForm.controls.footSize.reset(this.request?.kidFootSize);
            this.kidForm.controls.height.reset(this.request?.kidHeight);
            this.kidForm.controls.morningStop.reset(this.request?.stopMorning.replaceAll('-', ''));
            this.kidForm.controls.eveningStop.reset(this.request?.stopMorning.replaceAll('-', ''));
        }
        if (this._kid) {
            this.kidForm.controls.morningStop.reset(this.request?.stopMorning.replaceAll('-', '') ?? this._kid.morningStop?.id);
            this.kidForm.controls.eveningStop.reset(this.request?.stopMorning.replaceAll('-', '') ?? this._kid.eveningStop?.id);
            this.kidForm.controls.parents.reset(this._kid.parents.map(p => p.id!));
            this.kidForm.controls.siblings.reset(this._kid.siblings.map(p => p.id!));
            this.kidForm.controls.friends.reset(this._kid.friends.map(p => p.id!));
        }
        if (this.parent) {
            this.kidForm.controls.parents.reset([...this.kidForm.controls.parents.value ?? [], this.parent.id!]);
        }
    }

    public dialogText: string = '';

    @Output() public done = new EventEmitter<Kid | undefined>();

    constructor(
        private kidService: KidService,
        private msgs: MessagesService
    ) {
        this.kidForm = new FormGroup<KidForm>({
            name: new FormControl('', Validators.required),
            birthDate: new FormControl(null),
            gender: new FormControl(null),
            footSize: new FormControl(null),
            height: new FormControl(null),
            hasDeclaration: new FormControl(null),
            allowShooting: new FormControl(null),
            notes: new FormControl(null),
            friends: new FormControl([]),
            siblings: new FormControl([]),
            egn: new FormControl(null),
            parents: new FormControl([]),
            morningStop: new FormControl(null),
            eveningStop: new FormControl(null),
        });
    }

    public kidSubmit = (): void => {
        this._saveKid()
    }

    private _saveKid = async () => {
        try {
            const action = this.dialogText === 'Добави' ? 'добавен' : 'редактиран';
            let kid: Kid;
            if (action === 'добавен') {
                kid = await this.kidService.add(this.kidForm.value);
            } else {
                kid = await this.kidService.update({...this.kidForm.value, id: this.kid?.id });
            }
            this.msgs.success(`Дете ${kid.name} е успешно ${action}.`);
            this.done.emit(kid);
            this._kid = undefined;
            this.kidForm.reset();
        }
        catch (err) {
            this.msgs.error(err);
        }
    }

    public saveParentDone = (parent: Parent | undefined, dialog: IgxDialogComponent): void => {
        if (parent) {
            this.parents.push(parent);
            this.parents = [...this.parents];
            this.kidForm.controls.parents.reset([...this.kidForm.controls.parents.value ?? [], parent.id!])
        }

        dialog.close();
    }

    private _emptyKid = (): Kid => {
        return {
            name: '',
            gender: Gender.Male,
            notes: '',
            friends: [],
            siblings: [],
            sports: [],
            parents: [],
            packages: [],
        }
    };

    public clearSelection = (e: MouseEvent, value: FormControl<any>): void => {
        value.reset();
        e.stopPropagation();
    }

    public addParent = (e: Event, parentForm: EditParentFormComponent, dialog: IgxDialogComponent): void => {
        e.stopPropagation();
        parentForm.request = this.request;
        parentForm.parent = undefined;
        dialog.open();
    }

    public parseStop(item: CellType | BusStop | string | undefined): string {
        if (!item) {
            return '';
        }
        let stopId: string | undefined;
        let result = '';
        const busStop: BusStop = item as BusStop;
        if (busStop) {
            stopId = busStop.id;
        } else if (item.hasOwnProperty('grid')) {
            stopId = (item as CellType).value?.id;
        } else if (item.hasOwnProperty('id')) {
            stopId = (item as any).id;
        } else {
            stopId = item as string;
        }
        const stop = this.stops.find(s => s.id === stopId);
        result = stop?.name ?? '';
        return result;
    }
}
